import { ApiDataAccess, Dictionary, ReadonlyHttpApiListRepository } from '@softline/core';
import { inject, Injectable } from '@angular/core';
import { SOFTLINE_API_WWS_ARTIKELSTAMM_PRODUCT_SALES_PROMOTIONS } from '../artikelstamm.api';
import { PromotionQuery } from '../types/promotion.query';
import { SalesPromotion } from '../types/sales-promotion';

@Injectable()
export class SalesPromotionRepository extends ReadonlyHttpApiListRepository<SalesPromotion[], PromotionQuery> {

  constructor() {
    super(inject(ApiDataAccess), SOFTLINE_API_WWS_ARTIKELSTAMM_PRODUCT_SALES_PROMOTIONS);
  }

  override getLoadPathParams(params: PromotionQuery): Dictionary<unknown> {
    return { id: params.productId };
  }

  override getLoadQueryParams(params: PromotionQuery): Dictionary<unknown> {
    return {
      showAll: params.showAll ?? false,
      activePromotionsOnly: params.activePromotionsOnly ?? true
    }
  }
}
